import type { CancelReplanRow } from "../../../../../_logic/cancel-replan-contract"
import type { CancelAppointmentsIntent } from "../actions/cancelAppointments"

export const buildCancelAppointmentsIntent = ({
  rows,
  loading,
}: {
  rows: CancelReplanRow[]
  loading: boolean
}): CancelAppointmentsIntent => {
  if (loading) {
    return {
      kind: "blocked",
      label: "Termine stornieren und weiter",
      disabled: true,
      disabledReason: "Stornierbare Termine werden gerade geladen.",
      message: "Stornierbare Termine werden gerade geladen.",
    }
  }

  const activeRows = rows.filter((row) => !row.removed)
  const eventIds = activeRows.map((row) => row.event?.id).filter((id): id is string => Boolean(id))

  if (!eventIds.length) {
    return {
      kind: "blocked",
      label: "Termine stornieren und weiter",
      disabled: true,
      disabledReason: "Bitte mindestens einen Termin auswählen.",
      message: "Bitte mindestens einen Termin auswählen.",
    }
  }

  return {
    kind: "commit",
    label: "Termine stornieren und weiter",
    disabled: false,
    disabledReason: null,
    eventIds,
    rows,
  }
}
